/**
 *
 * @component 数据看板/组织切换通用控件
 *
 **/
import { Form } from 'antd';
import useStoreState from '&/utils/customHooks/useStoreState';
import { getOrganizationList } from '@/api/personCenter/organization';
import { Select } from '&/components/AntdEncapsulation';
import { observer } from 'mobx-react';
import './OrganizationSelect.scss';

function OrganizationSelect() {
    const appStore = useStoreState('appStore');
    const { entId, entOptions, setEntId, setEntOptions } =
        useStoreState('dataBoard');

    const { organization = {} } = appStore;
    const { branchId } = organization || {};
    // 组织字典
    const allOption = {
        value: null,
        label: intl.get('base.all'),
    };
    // const [organizationOptions, setOrganizationOptions] = useState([allOption]);

    const [optsLoading, setOptsLoading] = useState(false);

    useEffect(getOrganizations, []);

    function getOrganizations() {
        if (entOptions.length) return;
        setOptsLoading(true);
        getOrganizationList()
            .then(({ data }) => {
                const opts = [];
                for (const el of data) {
                    if (branchId && branchId !== +el.id) continue; // 如果是分公司只显示当前的分公司选项
                    opts.push({
                        value: el.id,
                        label: el.name,
                    });
                }
                if (data.length > 1) {
                    opts.unshift(allOption);
                } else {
                    setEntId(opts[0].value);
                }
                setEntOptions(opts);
            })
            .finally(() => {
                setOptsLoading(false);
            });
    }

    return (
        <Form.Item
            label={intl.get('dataBoard.organization')}
            className="organization-select">
            <Select
                loading={optsLoading}
                options={entOptions}
                value={entId}
                defaultActiveFirstOption
                placeholder={intl.get('message.steward.pleaseSelect')}
                style={{ minWidth: '10rem' }}
                onChange={setEntId}
            />
        </Form.Item>
    );
}

export default observer(OrganizationSelect);
